<template>
  <div>
    <div class="flex-just-betwn pt-18">
      <div class="w-45">
        <div>
          <el-table :data="list_data" :header-cell-style="{background: '#f9f9f9', color: '#333'}">
            <el-table-column label="意向达人信息">
              <template slot-scope="scope">
                <div>
                  <div class="flex">
                    <div class="w-90">平台:</div>
                    <div>{{scope.row.type_name}}</div>
                  </div>
                  <div class="flex">
                    <div class="w-90">达人昵称:</div>
                    <div>{{scope.row.nickname}}</div>
                  </div>
                  <div class="flex">
                    <div class="w-90">主页链接:</div>
                    <div>
                      <el-link :underline="false" type="primary" target="_blank" :href="scope.row.home_link">{{scope.row.nickname}}的主页</el-link>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="认领状态">
              <template slot-scope="scope">
                <div>
                  <div class="flex">
                    <div class="w-90">认领/分配状态:</div>
                    <div class="flex">
                      <div v-if="scope.row.status==1">待认领</div>
                      <div v-if="scope.row.status==2">联系中</div>
                      <div v-if="scope.row.status==3">已推荐</div>
                      <div v-if="scope.row.status==4">暂不合作</div>
                      <div v-if="scope.row.status==5">已取消</div>
                    </div>
                  </div>
                  <div v-if="scope.row.status==4">
                      暂不合作原因：
                      <span class="p-color-danger">
                        【{{scope.row.no_cooperation_type}}】
                        {{scope.row.no_cooperation_reason}}
                      </span>
                    </div>
                  <div class="flex">
                    <div class="w-90">沟通负责人:</div>
                    <div>{{scope.row.adid_name}}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 页码 -->
    <pagePagination :pageData="pageData" @pageChange="pageChange"></pagePagination>
  </div>
</template>

<script>
import pagePagination from "@/components/page_pagination.vue"
import utils from "@/utils/util.js";

export default {
  name: "kehuyixiang",
  components: {
    pagePagination
  },
  props: {
    cxorid: ''
  },
  data() {
    return {
      // user_info: "",
      rules: {
        adid: [
          {required: true, message: "请选择指派人", trigger: "blur"}
        ],
        no_cooperation_reason: [
          {required: true, message: "请填写不合作的理由",trigger: "blur" }
        ],
        no_cooperation_type: [
          {required: true, message: "请选择暂不合作类型",trigger: "blur" }
        ]
      },
      anreid_list: [], //12的列表
      status_list: [
        {value: "1", label: "待认领"},
        {value: "2", label: "联系中"},
        {value: "3", label: "已推荐"},
        {value: "4", label: "暂不合作"},
        {value: "5", label: "已取消"}
      ],
      list_data: [{}],//列表数据
      pageData: {
        count: 0,
        page: 1,
        offset: 10
      },
      apiUrl: {
        getAdidList: "/home/getAdidList", // 获取运营后台用户
        getIntentionKolList: "/home/getIntentionKolList" // 意向达人
      }
    };
  },
  created() {
    // this.user_info = utils.getAuth("user_info");
    this.getAdidList();
    this.getIntentionKolList();
  },
  methods: {
    // 获取运营后台用户(12,13,22,28人员)
    getAdidList() {
      //成员列表
      let _this = this;
      this.$http({
        method: "GET",
        url: _this.apiUrl.getAdidList,
        params: {
          anreid: "12,13,22,28",
        }
      }).then(res => {
        if (res.code == 1) {
          _this.anreid_list = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
    // 获取意向达人
    getIntentionKolList() {
      let _this = this;
      let params = {
        cxorid: this.cxorid,
        // status: this.form.status,
        // adid: this.form.adid,
        page: this.pageData.page,
        offset: this.pageData.offset
      };
      this.$http({
        method: "GET",
        url: _this.apiUrl.getIntentionKolList,
        params: params
      }).then(res => {
        if (res.code == 1) {
          _this.list_data = res.data;
          _this.pageData.count=res.count;
        } else {
          _this.$message.error(res.msg);
        }
      });
    },
    // 分页改变
    pageChange(page, pageSize){
      this.pageData.page = page;
      this.pageData.offset = pageSize;
      this.getIntentionKolList();
    },
  }
};
</script>

<style scoped>
.flex{
  display: flex;
  flex-wrap: wrap;
}
.flex-just-betwn{
  display: flex;
  justify-content: space-between;
}
.w-45{
  flex: 1;
  padding: 22px 30px;
  background-color: #ffffff;
}
.w-90{
  min-width: 90px;
  max-width: 91px;
}
.p-form{
  display: flex;
  display: -webkit-flex;
  display: -moz-flex;
  /* flex-wrap: wrap;
  flex: 1;
  justify-content: center; */
  align-items: center;
}
.fz-14{
  font-size: 14px;
}
</style>